import React, { Component } from 'react';

// import { Container } from './styles';

export default class Loading extends Component {
    render() {
        return (
            <div>
                {this.props.loading ?
                    <div className="loading">
                        <div className="gif">
                            <div className="lds-facebook"><div></div><div></div><div></div></div>
                            <p>Aguarde...</p>
                        </div>
                    </div>
                    : null}
            </div>
        );
    }
}
